import { MemberAPI } from "@radarly/api/member";
import { MemberRepo } from "./MemberRepo";

interface Dependencies {
  memberAPI: MemberAPI;
}

export class ConnectedMemberRepo implements MemberRepo {
  private memberAPI: MemberAPI;
  public constructor(dependencies: Dependencies) {
    this.memberAPI = dependencies.memberAPI;
  }
  public async getMember(id: number) {
    return await this.memberAPI.getMember(id);
  }
}
